// app/javascript/dashboard/routes/dashboard/bulkmessage/utils/useTextDisplay.js
import { ref } from 'vue';

export default function useTextDisplay() {
  // For the popup of long text viewing
  const showFullTextModal = ref(false);
  const fullTextContent = ref('');
  const fullTextTitle = ref('');

  // Functions for full text modal
  const openFullText = (title, content) => {
    fullTextTitle.value = title;
    fullTextContent.value = content;
    showFullTextModal.value = true;
  };

  const closeFullText = () => {
    showFullTextModal.value = false;
    fullTextContent.value = '';
    fullTextTitle.value = '';
  };

  // Function to limit text length with ellipsis
  const getTruncatedText = (text, maxLength = 100) => {
    if (!text) return '';
    // Convert to string if it's not already a string
    const textStr = String(text);
    if (textStr.length <= maxLength) return textStr;
    return textStr.substring(0, maxLength) + '...';
  };

  // Check if text needs truncation
  const needsTruncation = (text, maxLength = 100) => {
    if (!text) return false;
    // Convert to string if it's not already a string
    const textStr = String(text);
    return textStr.length > maxLength;
  };

  return {
    showFullTextModal,
    fullTextContent,
    fullTextTitle,
    openFullText,
    closeFullText,
    getTruncatedText,
    needsTruncation,
  };
}
